
<template>
<div id="page-camera-view">
  <iframe width="100%" height="500" :src="IframeSrc" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
  <br>
  {{CamName}}
 </div>
</template>
<script>
import {GET_CAMERA_DETAILS, CAMERA_REPORT_MUTATION,PLAY_CAMERA} from "@/graphql";

export default {
    data () {
    return {
      CamName:'',
      CamId:'',
      popupActive: false,
      IframeSrc:'',
    }
  },
  methods: {
    getCameraDetails() {
      var CamId = this.$route.params.camId.slice(257, -257);
      this.$apollo
        .query({
          query: GET_CAMERA_DETAILS,
          variables: {
            id: CamId,
          },
        }).then(response => {
        this.CamName=response.data.getCameraDetail.name
        this.CamId=response.data.getCameraDetail.id
        this.createCameraWatchTimeReport()

      })

    },
    createCameraWatchTimeReport() {
      this.$apollo
        .mutate({
          mutation: CAMERA_REPORT_MUTATION,
          variables: {
            camera_id: this.CamId,

          }
        })
        .then(response => {
          if (response.data.register.status=='SUCCESS'){

           console.log('done')

          }
        }) .catch(error => {

      });
    },
        PalyCamera(){
           this.$apollo
           .mutate({
            mutation: PLAY_CAMERA,
            variables: {
            id:'0',
           }
          })
            .then(response => {
              if (response) {
              this.IframeSrc=response.data.playCamera.embed_code
              this.popupActive=true
                          }
            }).catch(error => {
            console.log(error)
          });
    },

  },
  created(){
    this.PalyCamera()

    this.getCameraDetails()
    this.interval = setInterval(() => this.createCameraWatchTimeReport(), 60000);

  }
}
</script>
